import { modulePaths } from '@/routes/paths';
import type { LogisticsOrderType } from '@/modules/logistics/types';

export function buildLogisticsOrderNewUrl(options?: {
  reservationId?: string;
  type?: LogisticsOrderType;
  scheduledDate?: string;
}): string {
  const sp = new URLSearchParams();
  if (options?.reservationId) sp.set('reservation', options.reservationId);
  if (options?.type) sp.set('type', options.type);
  if (options?.scheduledDate) sp.set('date', options.scheduledDate);
  const q = sp.toString();
  return q
    ? `${modulePaths.logistics}/nueva?${q}`
    : `${modulePaths.logistics}/nueva`;
}

export function parseLogisticsOrderPrefill(
  searchParams: URLSearchParams,
): {
  reservationId?: string;
  type?: LogisticsOrderType;
  scheduledDate?: string;
} {
  const reservationId = searchParams.get('reservation') ?? undefined;
  const typeRaw = searchParams.get('type');
  const scheduledDate = searchParams.get('date') ?? undefined;
  const type =
    typeRaw === 'delivery' || typeRaw === 'pickup' || typeRaw === 'transfer'
      ? typeRaw
      : undefined;
  const out: {
    reservationId?: string;
    type?: LogisticsOrderType;
    scheduledDate?: string;
  } = {};
  if (reservationId) out.reservationId = reservationId;
  if (type) out.type = type;
  if (scheduledDate) out.scheduledDate = scheduledDate;
  return out;
}
